import React from 'react'
import "./siteswap.scss"
import { siteSwap } from './../../constants'
import dots from './../../assets/dole-juice-pattern.svg'
import titleImg from './../../assets/modules/lemonade-headline@3x.png'

const SiteSwap = () => {
    const { TITLE, BUTTON } = siteSwap;

    const title = TITLE.split('/').map((item, i) => {
        return (
            <span key={i}>
                {item}
                <br />
            </span>
        )
    })
    return (
        <div className="site-swap-mod">
            <div className="site-swap-mod__text">
                <h3>{TITLE}<img src={titleImg} alt=""/></h3>
                <a href={BUTTON.URL}><button>{BUTTON.TITLE}</button></a>
            </div>
        </div>
    )
}

export default SiteSwap
